import { useQuery } from "@tanstack/react-query";

import { IUserState } from "../models";
import { $api, globalConst } from "..";

export function useUserData() {
  const { data, ...arg } = useQuery<{ user: IUserState }>({
    queryKey: [globalConst.queryKeys.USER_DATA],
    queryFn: async () => {
      const { data } = await $api.get('/mypage', {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      return { user: data || [] };
    }
  });

  return { ...data, ...arg };
}
